export const evhInfoWindowSelector = ({evhInfoWindow}) => evhInfoWindow